import styled from "styled-components";
import { useRecoilValue } from "recoil";

import CheckBox from "components/atoms/input/CheckBox";
import { TextBase } from "components/atoms/text";
import SHADOWS from "components/atoms/shadows";

import useUserMe from "apis/queries/useUserMe";
import useCompanyMe from "apis/queries/useCompanyMe";
import useEditUserIsClosed from "apis/mutations/user/useEditUserIsClosed";
import useEditCompanyIsClosed from "apis/mutations/company/useEditCompanyIsClosed";

import authAtom from "stores/auth";

interface Props {
  onClose: () => void;
}

// 가이드 동영상 모달
const ModalGuideVideo = ({ onClose }: Props) => {
  const auth = useRecoilValue(authAtom);
  const userMe = useUserMe();
  const companyMe = useCompanyMe();
  const me = companyMe || userMe;

  // 다시보지않기 상태 변경 api - 일반회원
  const editUserIsClosed = useEditUserIsClosed({
    onSuccess: () => onClose(),
  });

  // 다시보지않기 상태 변경 api - 전문가회원
  const editCompanyIsClosed = useEditCompanyIsClosed({
    onSuccess: () => onClose(),
  });

  // 다시보지 않기 클릭 이벤트
  const handleEditCloseStatus = (checked: boolean) => {
    if (auth.type === "user") {
      editUserIsClosed.mutate({ isClosed: checked });
    } else {
      editCompanyIsClosed.mutate({ isClosed: checked });
    }
  };

  if (!me) return null;

  return (
    <Container>
      <VideoWrap>
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/NZgKOj7RBAQ?si=PTQ0KAK1WA1B4TB2"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </VideoWrap>
      <div className="flex justify-between mt-3">
        <CheckBox
          className="gap-2"
          children={
            <TextBase className="text-white" bold>
              다시 보지 않기
            </TextBase>
          }
          checked={me.isClosed}
          onChange={({ target }) => handleEditCloseStatus(target.checked)}
        />
        <button onClick={onClose} className="text-base font-bold text-white">
          닫기
        </button>
      </div>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 101;
  transform: translate(-50%, -50%);
  width: 1000px;
`;

const VideoWrap = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.5%;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: ${SHADOWS.modal};

  iframe {
    position: absolute;
  }
`;

export default ModalGuideVideo;
